import { connect } from 'react-redux';

import {
    getTeamList,
    getUserList,
    isLoadingTeams,
    isLoadingUsers,
    selectAchievementsTypes,
    selectAllAchievements,
    selectIsAchievementsTypesLoading,
    selectIsAllAchievementsLoading,
    selectIsUploadingAchievementImage,
    selectUploadAchievementImageError,
    selectUploadAchievementImageSuccess,
    selectUploadedAchievementImageData,
} from 'core/selectors';
import {
    deleteAchievement,
    getAchievementsTypes,
    getAllAchievements,
    postAchievement,
    updateAchievement,
    uploadAchievementImage,
} from 'core/slices/achievements';
import { getTeams } from 'core/slices/teams';
import { getUsers } from 'core/slices/users';

import AchievementManagement from '../../../components/hall/admin/AchievementManagement';

export default connect(
    state => ({
        achievementsTypes: selectAchievementsTypes(state),
        isAchievementsTypesLoading: selectIsAchievementsTypesLoading(state),
        allAchievements: selectAllAchievements(state),
        isAllAchievementsLoading: selectIsAllAchievementsLoading(state),
        users: getUserList(state),
        isUsersLoading: isLoadingUsers(state),
        teams: getTeamList(state),
        isTeamsLoading: isLoadingTeams(state),
        isUploadingAchievementImage: selectIsUploadingAchievementImage(state),
        uploadAchievementImageSuccess: selectUploadAchievementImageSuccess(state),
        uploadAchievementImageError: selectUploadAchievementImageError(state),
        uploadedAchievementImageData: selectUploadedAchievementImageData(state),
    }),
    {
        getUsers,
        getTeams,
        postAchievement,
        updateAchievement,
        deleteAchievement,
        getAllAchievements,
        uploadAchievementImage,
        getAchievementsTypes,
    },
)(AchievementManagement); 